/**
 * Custom DOM event that opens a TickerSearch in edit mode, optionally seeded
 * with an initial query. Dispatched by the chart keyboard layer on the
 * combobox trigger (`[data-companion-label$="ticker-search"]`) when the user
 * types a bare letter over a chart: the typed character must land in the
 * input rather than be swallowed by the open gesture.
 *
 * Lives in a companion .ts file (not ticker-search.tsx) so the component file
 * keeps exporting only components for Vite fast refresh.
 */
export const TICKER_SEARCH_OPEN_EVENT = 'edge:ticker-search-open'

export interface TickerSearchOpenDetail {
  /** Initial query for the input; caret lands after it. Empty opens as usual. */
  seed?: string
}

/** Build the open event; `bubbles` so the component's container hears it when
 *  the dispatch target is the inner combobox trigger. */
export function tickerSearchOpenEvent(seed?: string): CustomEvent<TickerSearchOpenDetail> {
  return new CustomEvent(TICKER_SEARCH_OPEN_EVENT, { detail: { seed }, bubbles: true })
}
